import axios from "axios";
import { apiConstants } from "../_constants";

export const settings = {
  baseURL:
    process.env.NODE_ENV === "production"
      ? `/automated-terminal-registration-system`
      : "https://automated-terminal-registration-report.k8.isw.la/",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json",
    "Content-Type": "application/json;charset",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "X-XSRF-TOKEN": apiConstants.XSRF,
  },
};

export const instance = axios.create(settings);
if (process.env.NODE_ENV !== "production") {
  instance.defaults.headers.common["Authorization"] =
    "bearer eyJhbGciOiJSUzI1NiJ9.eyJsYXN0TmFtZSI6IkFiYWxhIiwiZmlyc3RMb2dpbiI6ZmFsc2UsInVzZXJfbmFtZSI6ImtwYXJvYm8uYWJhbGEiLCJtb2JpbGVObyI6IjIzNDgxNjU3OTQ2MTAiLCJjbGllbnRfZGVzY3JpcHRpb24iOm51bGwsImNsaWVudF9pZCI6Imlzdy1wb3J0YWwiLCJmaXJzdE5hbWUiOiJLcGFyb2JvIiwiZW1haWxWZXJpZmllZCI6dHJ1ZSwiYXVkIjpbImFyYml0ZXIiLCJjYWMtdmVyaWZpY2F0aW9uLXNlcnZpY2UiLCJjYWVzYXIiLCJlY2hhbmdlLXNlcnZpY2UiLCJlc2Nyb3ctc2VydmljZSIsImlwZy1zZXR0bGVtZW50IiwiaXN3LWNvbGxlY3Rpb25zIiwiaXN3LWNvcmUiLCJpc3ctbGVuZGluZy1zZXJ2aWNlIiwiaXN3LXBheW1lbnRnYXRld2F5IiwicGFzc3BvcnQiLCJwcm9qZWN0LXgtbWVyY2hhbnQiLCJ0cmFuc2Zlci1zZXJ2aWNlLXBvcnRsZXQiLCJ2ZXJ2ZS1saWZlLWFkbWluLXNlcnZpY2UiLCJ2ZXJ2ZS1yZXdhcmQtdWkiLCJ3YWxsZXQtYWRtaW4tc2VydmljZSJdLCJzY29wZSI6WyJwcm9maWxlIl0sImV4cCI6MzE1NzExNjY5MCwibW9iaWxlTm9WZXJpZmllZCI6dHJ1ZSwiY2xpZW50X2xvZ28iOm51bGwsImp0aSI6ImQwYjAxODFmLTRlYTgtNGViZi1hMDNkLWI0ODA1ZDM5YTA4MCIsImVtYWlsIjoia3Bhcm9iby5hYmFsYUBpbnRlcnN3aXRjaGdyb3VwLmNvbSIsInBhc3Nwb3J0SWQiOiI4RDY2Mzc4Mi0xRjk2LTMzRjctQjYwQi0zRTRGNEY0RjcwNjUifQ.Uqp7wKBHb8mwd-8nOR3Yli4L0lQx3mGnBaoTjjsvXaN_XKuiYlRHSSAwKXuA9Gh-mobS6o-H89Jt3KAMvZm2fzRC78rPrM-N_ayA6Pa4yffmRIQ1h5PlaoUN7fbbzpqwNTnKJjR9PbGw6Ox0a3SPCtZF2xZMvuOK_bwty-75rrcdTedoigVFzZagBqycc4OU5VWLNf69wqfd1Ows9qKpRbgQGuJpiH78WeI8qqFO0s7EQWzP-AnKInODthc8ZQzokBuiqVP6z6KpFccCOB97wJSTQWqtkXRmBjaNobRHMQpUYFAXR2oZR5aqFtLK4rvwbplyANmdow8hUEO2I2jeFg";
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: instance.get,
  post(url, request) {
    return instance
      .post(url, request)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  put(url, request) {
    return instance
      .put(url, request)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  delete(url, request) {
    return instance
      .delete(url, request)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  patch(url, request) {
    return instance
      .patch(url, request)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
};
